var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 29H26V26H14V29ZM14 23H26V20H14V23ZM11 35C10.175 35 9.46875 34.7062 8.88125 34.1187C8.29375 33.5312 8 32.825 8 32V8C8 7.175 8.29375 6.46875 8.88125 5.88125C9.46875 5.29375 10.175 5 11 5H23L32 14V32C32 32.825 31.7062 33.5312 31.1187 34.1187C30.5312 34.7062 29.825 35 29 35H11ZM21.5 15.5V8H11V32H29V15.5H21.5Z",
    fill: "currentColor"
  })));
};
export default SvgFile;